import { Separator } from "@/components/ui/separator";

interface FeatureItemProps {
  title: string;
  description: string;
}

export const FeatureItem = ({ title, description }: FeatureItemProps) => {
  return (
    <div className="bg-tami-light rounded-xl px-3 py-2 md:px-4 md:py-3 flex flex-col  gap-2 md:gap-3 md:min-h-[60px]">
      <div className="flex-shrink-0 md:min-w-[120px]">
        <span className="font-bold text-tami-dark text-sm md:text-base ">
          {title}
        </span>
      </div>

      <Separator className=" w-full bg-tami-dark/20 flex-shrink-0" />
      
      <span className="text-tami-dark text-sm md:text-base leading-relaxed text-start ">
        {description}
      </span>
    </div>
  );
};
